import { SettingType } from "../recoil/settings";
import {
  ACTION_MESSAGE_TYPE,
  CANCEL_PAY_REQUEST_MESSAGE_TYPE,
  ECHO_MESSAGE_TYPE,
  ORDER_COMPLETE_MESSAGE_TYPE,
  PAY_REQUEST_MESSAGE_TYPE,
  PONG_MESSAGE_TYPE,
  RESTART_PAY_REQUEST_MESSAGE_TYPE,
  SET_ENV_MESSAGE_TYPE,
  TOAST_MESSAGE_TYPE,
  paymentRealmType,
  postMessageActionType,
  postMessageCancelPayType,
  postMessageEchoType,
  postMessageOrderCompleteType,
  postMessagePayType,
  postMessagePongType,
  postMessageRestartPayType,
  postMessageSetEnvType,
  postMessageToastType,
  postMessageType,
} from "../recoil/type";
import { getEncryptObject } from "../utils/crypto";

const MessageController = {
  getPayApprovalRequestData: (
    amount: number,
    store_id: number,
    payment_request_id: number
  ) => {
    console.log(payment_request_id);
    let payRequestData: postMessagePayType = {
      type: PAY_REQUEST_MESSAGE_TYPE,
      data: {
        amount,
        store_id,
        requested_at: new Date(),
        payment_request_id,
      },
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getPayCancelRequestData: (payment: paymentRealmType) => {
    let payRequestData: postMessageCancelPayType = {
      type: CANCEL_PAY_REQUEST_MESSAGE_TYPE,
      data: payment,
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getSetEnvRequestMessage: (env: {
    env_type: string;
    name: string;
    value: string;
  }) => {
    let payRequestData: postMessageSetEnvType = {
      type: SET_ENV_MESSAGE_TYPE,
      data: env,
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getLogoutRequestData: () => {
    let payRequestData: postMessageActionType = {
      type: ACTION_MESSAGE_TYPE,
      data: { action: "restart" },
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getPayRestartRequestData: () => {
    let payRequestData: postMessageRestartPayType = {
      type: RESTART_PAY_REQUEST_MESSAGE_TYPE,
      data: {},
    };

    let payEncryptMessage = getEncryptObject(payRequestData);

    return payEncryptMessage;
  },

  getOrderCompleteData: () => {
    let requestData: postMessageOrderCompleteType = {
      type: ORDER_COMPLETE_MESSAGE_TYPE,
      data: {},
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },

  getEchoData: (data: any) => {
    let requestData: postMessageEchoType = {
      type: ECHO_MESSAGE_TYPE,
      data,
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },

  getPongData: () => {
    let requestData: postMessagePongType = {
      type: PONG_MESSAGE_TYPE,
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },

  getActionData: (action: any, params: any) => {
    let requestData: any = {
      type: "action",
      action,
      params,
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },

  getToastData: (msg: string, ms: number) => {
    let requestData: postMessageToastType = {
      type: TOAST_MESSAGE_TYPE,
      data: {
        msg,
        ms,
      },
    };

    let payEncryptMessage = getEncryptObject(requestData);

    return payEncryptMessage;
  },
};

export default MessageController;
